import React, { useState } from 'react';
import { Box, Button, Group, Tabs, Text } from '@mantine/core';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import LoaderOverlay from '../../Utilities/LoadingOverLay';
import OverviewTab from './OverviewTab';

import {
  IconBuildingCommunity,
  IconChecklist,
  IconCurrencyRupee,
  IconHome2,
  IconImageInPicture,
  IconLayoutDashboard,
  IconMapPin,
  IconRulerMeasure,
  IconSettings,
  IconStar,
  IconWallet,
} from '@tabler/icons-react';
import Floorplan from './Floorplan';
import AmentiesTab from './AmentiesTab';
import SpecificationTab from './SpecificationTab';
import LocationTab from './LocationTab';
import AddImages from './AddImagesTab';
import AddImagesTab from './AddImagesTab';

function AddProperty() {
  
  const location = useLocation();
  const id = location.state?.id;
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [amenities, setAmenities] = useState('');
  const [specification, setSpecification] = useState('');
  const [map, setMap] = useState('');
  const [landmarks, setLandmarks] = useState('');

  // All tab definitions here
  const tabItems = [
    {
      value: 'overview',
      label: 'Overview',
      icon: IconLayoutDashboard,
      content: <OverviewTab id={id} setAmenities={setAmenities}  setSpecification={setSpecification}  setMap={setMap}  setLandmarks={setLandmarks} />,
    },
    {
      value: 'floorplan',
      label: 'Floor Plan',
      icon: IconRulerMeasure,
      content: <Floorplan id={id}/>,
    },
    {
      value: 'amenities',
      label: 'Amenities',
      icon: IconChecklist,
      content: <AmentiesTab id={id} amenities={amenities} />,
    },
    {
      value: 'specification',
      label: 'Specification',
      icon: IconSettings,
      content: <SpecificationTab id={id} specification={specification} />,
    },
    {
      value: 'location',
      label: 'Location',
      icon: IconMapPin,
      content: <LocationTab id={id} map={map} landmarks={landmarks} />,
    },
    {
      value: 'add-images',
      label: 'Add Images',
      icon: IconImageInPicture,
      content: <AddImagesTab id={id}   />,
    }
    
  ];

  if (loading) return <LoaderOverlay />;

  return (
    <Box
      mx="auto"
      sx={(theme) => ({
        backgroundColor: 'white',
        padding: theme.spacing.xl,
        borderRadius: theme.radius.md,
        boxShadow: theme.shadows.md,
        minHeight: '100%',
      })}
    >
      <Group position="apart" mb="md">
        <h2>{id ? 'Edit Property' : 'Create Property'}</h2>
        <Button onClick={() => navigate('/dashboard/property')}>Back</Button>
      </Group>

      <Tabs
        defaultValue="overview"
        styles={(theme) => ({
          tab: {
            display: 'flex',
            alignItems: 'center',
            fontWeight: 500,
            fontSize: theme.fontSizes.md,
            gap: 8,
            color: theme.colors.gray[7],
            '&[data-active]': {
              color: theme.colors.cyan[6],
            },
          },
          tabIcon: {
            color: theme.colors.gray[6],
            '[data-active] &': {
              color: theme.colors.blue[6],
            },
          },
        })}
      >
        <Tabs.List mb={10}>
          {tabItems.map(({ value, label, icon: Icon }) => (
            <Tabs.Tab key={value} value={value} icon={<Icon size="1rem" />}>
              {label}
            </Tabs.Tab>
          ))}
        </Tabs.List>

        {tabItems.map(({ value, content }) => (
          <Tabs.Panel key={value} value={value} pt="lg">
            {content}
          </Tabs.Panel>
        ))}
      </Tabs>
    </Box>
  );
}

export default AddProperty;
